var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-page",
      class: {
        "layout-mode-dialog": _vm.layoutMode === "dialog",
        "layout-mode-page": _vm.layoutMode === "page",
        "layout-mode-tab": _vm.layoutMode === "tab",
        "show-summary": _vm.showSummary,
      },
    },
    [
      _vm.$slots.search
        ? _c("div", { staticClass: "search-bar" }, [_vm._t("search")], 2)
        : _vm._e(),
      _vm.$slots["table-header"]
        ? _c(
            "div",
            { staticClass: "table-header" },
            [_vm._t("table-header")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "table-content",
          class: { "table-content-summary": _vm.showSummary },
        },
        [_vm._t("table-content", null, { tableProps: _vm.tableProps })],
        2
      ),
      _vm.$slots.pagination
        ? _c(
            "div",
            { staticClass: "table-pagination" },
            [_vm._t("pagination")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }